// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"2af9a43a","213":"d8cbe925","304":"8a65c4d8","536":"a5dfbddc","603":"92eb1ad5","692":"4c143eab","874":"8a65c4d8","934":"6a75fc93"}[chunkId] + ".chunk.css";
};